module.exports = __webpack_public_path__ + "static/media/EHS-Infection-Control-Policy.d37b457f.pdf";